import { useCallback, useEffect, useState } from "react";

const THEME_KEY = "neutral-theme";

function currentTheme() {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function useTheme() {
  // public/theme-init.js has already applied the saved theme (light by default).
  const [theme, setTheme] = useState(currentTheme);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", theme === "dark" ? "#09090b" : "#ffffff");
  }, [theme]);

  const toggleTheme = useCallback(() => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    try { localStorage.setItem(THEME_KEY, next); } catch { /* Storage is optional. */ }
  }, [theme]);

  return { theme, toggleTheme };
}
